import type { WatchlistAccount } from '@interfaces/watchList';

/**
 * Representative mock dataset for the Watch List.
 *
 * Coverage:
 * - Row at exactly bandConsumedPercentage === 75
 * - Row at ≥ 95 %
 * - Row with hasInternational: true
 * - Row with isStale: true
 * - Rows whose trigger.reason mirrors Drift Queue vocabulary ("Cash deposit", "Ext. transfer")
 * - Varied accountType, custodian, portfolioValue, asOfDate
 * - No row with hasBreached: true — reflects the intended input set for the Watch List
 */
export const MOCK_WATCH_LIST: WatchlistAccount[] = [
  {
    id: 'wl-001',
    portfolioName: 'Growth Portfolio',
    accountNumber: 'ACC-10042',
    householdName: 'Johnson Family',
    accountType: 'RRSP',
    custodian: 'National Bank',
    portfolioValue: 248_500,
    asOfDate: '2026-05-20',
    isStale: false,
    hasInternational: false,
    hasBreached: false,
    trigger: { reason: 'Cash deposit', occurredAt: '2026-05-19T14:23:00Z' },
    bandConsumedCashPercentage: 78,
    bandConsumedPositionPercentage: 62,
    bandConsumedPercentage: 78,
    thresholdLabel: '±5% cash / ±8%',
  },
  {
    id: 'wl-002',
    portfolioName: 'Conservative Income',
    accountNumber: 'ACC-10087',
    householdName: 'Tremblay Household',
    accountType: 'TFSA',
    custodian: 'Desjardins',
    portfolioValue: 112_000,
    asOfDate: '2026-05-20',
    isStale: false,
    hasInternational: true,
    hasBreached: false,
    trigger: { reason: 'Ext. transfer', occurredAt: '2026-05-18T09:10:00Z' },
    bandConsumedCashPercentage: 55,
    bandConsumedPositionPercentage: 97,
    bandConsumedPercentage: 97,
    thresholdLabel: '±6% cash / ±10%',
  },
  {
    id: 'wl-003',
    portfolioName: 'Balanced Growth',
    accountNumber: 'ACC-10113',
    householdName: 'Patel Family',
    accountType: 'Non-Registered',
    custodian: 'TD Direct',
    portfolioValue: 560_000,
    asOfDate: '2026-05-19',
    isStale: true,
    hasInternational: true,
    hasBreached: false,
    trigger: {
      reason: 'Sector concentration',
      occurredAt: '2026-05-17T16:05:00Z',
    },
    bandConsumedCashPercentage: 80,
    bandConsumedPositionPercentage: 76,
    bandConsumedPercentage: 80,
    thresholdLabel: '±4% cash / ±7%',
  },
  {
    id: 'wl-004',
    portfolioName: 'Retirement Core',
    accountNumber: 'ACC-10204',
    householdName: 'Williams & Smith',
    accountType: 'LIRA',
    custodian: 'RBC Direct',
    portfolioValue: 385_200,
    asOfDate: '2026-05-20',
    isStale: false,
    hasInternational: false,
    hasBreached: false,
    trigger: { reason: 'Cash deposit', occurredAt: '2026-05-20T08:30:00Z' },
    bandConsumedCashPercentage: 75,
    bandConsumedPositionPercentage: 70,
    bandConsumedPercentage: 75,
    thresholdLabel: '±5% cash / ±8%',
  },
  {
    id: 'wl-005',
    portfolioName: 'Global Diversified',
    accountNumber: 'ACC-10255',
    householdName: 'Chen Household',
    accountType: 'RESP',
    custodian: 'Questrade',
    portfolioValue: 95_800,
    asOfDate: '2026-05-20',
    isStale: false,
    hasInternational: true,
    hasBreached: false,
    trigger: { reason: 'Ext. transfer', occurredAt: '2026-05-19T11:45:00Z' },
    bandConsumedCashPercentage: 88,
    bandConsumedPositionPercentage: 83,
    bandConsumedPercentage: 88,
    thresholdLabel: '±6% cash / ±9%',
  },
  {
    id: 'wl-006',
    portfolioName: 'Income Builder',
    accountNumber: 'ACC-10311',
    householdName: 'Okafor Family',
    accountType: 'RRSP',
    custodian: 'BMO InvestorLine',
    portfolioValue: 203_700,
    asOfDate: '2026-05-18',
    isStale: true,
    hasInternational: false,
    hasBreached: false,
    trigger: {
      reason: 'Dividend reinvestment',
      occurredAt: '2026-05-15T10:00:00Z',
    },
    bandConsumedCashPercentage: 91,
    bandConsumedPositionPercentage: 79,
    bandConsumedPercentage: 91,
    thresholdLabel: '±5% cash / ±8%',
  },
];
